import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { multipleEmailValidation, singleEmailValidation } from "@/services/misc/functions/ValidationFunctions";

export default class CreateLetsEncryptCertificateForm {
  public websiteId: number = 0;

  public subDomains: string[] = [];

  public email?: string = '';

  public vhostAliases: boolean = false;

  public autoRenew: boolean = false;

  public rules: { [key: string]: FormValidationFunction[] } = {
    websiteId: [
      (v: number) => v <= 0 || 'Invalid website selected',
    ],
    email: [
      ...singleEmailValidation(),
    ],
  };
}
